import { commonShortFieldLabels } from "./common-short-fields";

export const examAdminExecutionAttackDefense = {
  pageTitle: "夺旗环境管理",
  pageSubtitle: "集中查看夺旗题环境创建记录与 Flag 提交记录。",
  sourceExam: "考试",
  sourceDebug: "调试",
  statsTotal: "环境总数：{count}",
  statsRunning: "运行中：{count}",
  statsDestroyed: "已销毁：{count}",
  statsDynamic: "动态 Flag：{count}",
  statsStatic: "静态 Flag：{count}",
  columns: {
    instanceId: "实例 ID",
    source: "来源",
    examInfo: "考试信息",
    question: "题目",
    questionVersionCode: "题目版本编码",
    candidate: "考生",
    status: "环境状态",
    containerId: "容器 ID",
    webEndpoint: "Web 入口",
    imageName: "镜像标识",
    flagMode: "Flag 模式",
    flagEnvKey: "Flag 环境变量键",
    flagValue: "Flag",
    flagSha256: "Flag 哈希",
    creator: "创建人",
    lifetime: "生存时间",
    startedAt: "开始时间",
    createdAt: commonShortFieldLabels.createdAt,
    expiresAt: "过期时间",
    destroyedAt: "销毁时间",
    actions: "操作",
  },
  actions: {
    viewFlagSubmissions: "查看 Flag 提交",
    viewAttempt: "查看作答",
    recycleInstance: "回收实例",
  },
  messages: {
    recycleSubmissionSubmitted: "环境实例销毁请求已提交",
  },
  flagSubmissionsTitle: "Flag 提交记录（实例 #{id}）",
  flagSubmissionsEmpty: "暂无 Flag 提交记录",
  flagSubmissionColumns: {
    id: "记录 ID",
    flagValue: "Flag 值",
    result: "是否正确",
    submittedAt: "提交时间",
  },
  resultCorrect: "正确",
  resultIncorrect: "错误",
  resultUnknown: "未知",
  statusRunning: "运行中",
  statusReady: "就绪",
  statusEvaluated: "已评测",
  statusProvisioning: "创建中",
  statusPending: "等待中",
  statusDestroyed: "已销毁",
  statusDebug: "调试中",
  flagModeDynamic: "动态",
  flagModeStatic: "静态",
  examInfoEmpty: "调试实例",
} as const;
